import BigImg from '../../components/BigImg.vue';
import {Toast} from "vant";

var that;
var timer;
export default {
    setup() {
        const onClickLeft = () => history.back();
        return {
            onClickLeft,

        };
    },
    components: {
        BigImg,
    },
    data() {
        return {
            valueBookShop: '0',
            optionBookShop: [
                { text: '书香卡（365元）', value: '0' },
                { text: '墨香卡（520元）', value: '1' },
                // { text: '文香卡（899元）', value: '2' },
            ],
            cardNumber: '',
        };
    },

    created() {

    },

    mounted() {

    },
    unmounted() {

    },
    methods: {
        createNumber: function () {
            console.log(":::cardNumber", this.cardNumber);
            console.log(":::valueBookShop", this.optionBookShop[this.valueBookShop].text);
            this.$api.createNumber({
                params: {
                    cardNumber: this.cardNumber,
                    cardName: this.optionBookShop[this.valueBookShop].text,
                },
                success: function (res) {
                    console.log(":::success", res)
                    Toast('生成成功');
                }.bind(this),
                fail: function (res) {
                    console.log(":::fail", res)
                    Toast('生成失败');
                }
            })
        }
    }
};